import { SideModal } from '@design-system/components/modal/sideModal';
import {
  UseEditVideoVMParams,
  useEditVideoVM,
} from '../view-models/editVideo.viewModel';
import { EditVideoView } from './editVideo.view';
import { Tag } from '@design-system/components/tag/tag';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { Button } from '@design-system/components/button/button';

type EditVideoModalParams = UseEditVideoVMParams;

export const EditVideoModal = (p: EditVideoModalParams) => {
  const vm = useEditVideoVM(p);

  return (
    <>
      <SideModal
        isOpen={true}
        onClose={p.onClose}
        title={p.video.name}
        titleClassName="text-ellipsis max-w-[500px] whitespace-nowrap overflow-hidden"
        headerComponents={<Tag label={vm.tagLabel} />}
        primaryCta={{
          caption: 'Save',
          onClick: () => vm.dispatch('submitEdit'),
        }}
        drawerSx={{
          '&.MuiDrawer-root > .MuiDrawer-paper': {
            width: { lg: 850 },
            paddingX: '36px',
            overflow: 'auto',
          },
        }}
      >
        <EditVideoView {...vm} />
      </SideModal>
      <Modal
        isOpen={vm.showReplaceConfirmation}
        onClose={() => vm.dispatch('closeConfirmation')}
        title="Replacing file?"
        disableBackdropClick={true}
        modalClassName="w-full md:w-[450px]"
      >
        <div className="flex flex-col gap-6">
          <Typography variant="body" size="large">
            Replace the file with a new one from your device.
          </Typography>
          <Typography variant="body" size="large">
            This action cannot be undone, and changes at the library level won't
            affect files already in workouts.
          </Typography>
          <div className="flex flex-col md:flex-row justify-between">
            <Button
              onClick={() => vm.dispatch('closeConfirmation')}
              color="neutral"
              variant="text"
              className="w-full md:w-[200px]"
            >
              Cancel
            </Button>
            <Button
              onClick={() => vm.dispatch('replaceVideo')}
              color="neutral"
              className="w-full md:w-[200px]"
            >
              Proceed
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
